import { jsx as _jsx } from "react/jsx-runtime";
export const PageSubtitle = ({ children }) => {
    return (_jsx("div", Object.assign({ className: "page-subtitle" }, { children: _jsx("span", Object.assign({ className: "page-subtitle__subtitle" }, { children: children })) })));
};
